package link.erpango.quip.db

import kotlin.Double
import kotlin.Long
import kotlin.String

public data class SparePartDocument(
  public val id: Long,
  public val server_id: Long?,
  public val spare_part_id: Long,
  public val server_spare_part_id: Long?,
  public val vehicle_vin: String,
  public val name: String,
  public val file_path: String,
  public val file_type: String,
  public val created_at: String,
  public val size_mb: Double,
  public val updated_at: String?,
)
